/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GetPlanResponseDto } from './GetPlanResponseDto';

export type GetPlanTenantResponseDto = (GetPlanResponseDto & {
    accessEndDate?: number;
    accountState?: GetPlanTenantResponseDto.accountState;
    isIntercomEnabled?: boolean;
    planType?: GetPlanTenantResponseDto.planType;
    totalAccessPeriodDays?: number;
} & {
    accountState: GetPlanTenantResponseDto.accountState;
    isIntercomEnabled: boolean;
    planType: GetPlanTenantResponseDto.planType;
});

export namespace GetPlanTenantResponseDto {

    export enum accountState {
        TRIAL = 'TRIAL',
        ACTIVE = 'ACTIVE',
        PAST_DUE = 'PAST_DUE',
        SUSPENDED = 'SUSPENDED',
    }

    export enum planType {
        REGULAR = 'REGULAR',
        FREE_TRIAL = 'FREE_TRIAL',
    }


}
